import React from 'react';

import DeviceManagementModals from '~/DeviceManagementModals';

export const ApplicationContentWrapper = ({ children }) => (
    // container-fluid fluid-large
    <React.Fragment id='devicemanagement devicemanagement-frame'>
        {/*<ReloadProgress period={20000}/>*/}
        <DeviceManagementModals/>
        <React.Fragment id='devicemanagement-frame-content'>
            {children}
        </React.Fragment>
    </React.Fragment>
);

export default ApplicationContentWrapper;
